const BpmnPropertiesProvider = require('./BpmnPropertiesProvider');

module.exports = {
  __init__: ['propertiesProvider'],
  propertiesProvider: ['type', BpmnPropertiesProvider]
};



// WEBPACK FOOTER //
// ./src/client/common/bpmn-properties-provider/index.js